import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { allowedExtensions, validExtensionTypes } from 'shared/utils';

import { BackgroundDragDropWrapper } from './styles';

const BackgroundDragDrop = ({ className, onChangeFile, onError, children, isOnclick }) => {
  const { t } = useTranslation();
  const fileInputRef = useRef();
  const [isDrop, setIsDrop] = useState(false);

  const callOnChangeFile = (files) => {
    const validTypes = validExtensionTypes;
    const existFiles = files.map((file) => {
      const existExtensions = validTypes.some(
        (x) => file.name.toUpperCase().endsWith(x) || file.name.toLowerCase().endsWith(x)
      );
      if (!existExtensions) {
        onError(t('general_invalid_file_type'));
        const newFile = file;
        newFile.isValidFile = false;
        return newFile;
      }
      onError('');
      const newFile = file;
      newFile.isValidFile = true;
      return newFile;
    });
    onChangeFile(existFiles);
  };

  const onClickUploadSection = () => {
    fileInputRef?.current?.click();
  };

  const dragOver = (e) => {
    setIsDrop(true);
    e.preventDefault();
  };

  const dragEnter = (e) => {
    setIsDrop(true);
    e.preventDefault();
  };

  const dragLeave = (e) => {
    setIsDrop(false);
    e.preventDefault();
  };

  const fileDrop = (e) => {
    e.preventDefault();
    const { files } = e.dataTransfer;
    const newFiles = [...files];
    setIsDrop(false);
    callOnChangeFile(newFiles);
  };

  const fileSelected = (e) => {
    if (fileInputRef.current.files.length) {
      const { files } = fileInputRef.current;
      const newFiles = [...files];
      callOnChangeFile(newFiles);
      e.target.value = '';
    }
  };

  return (
    <>
      <BackgroundDragDropWrapper
        onClick={onClickUploadSection}
        aria-hidden="true"
        onDragOver={dragOver}
        onDragEnter={dragEnter}
        onDragLeave={dragLeave}
        onDrop={fileDrop}
        className={className}
        isDrop={isDrop}
      >
        {children}
        {isOnclick && (
          <input
            ref={fileInputRef}
            type="file"
            onChange={fileSelected}
            multiple
            accept={allowedExtensions}
          />
        )}
      </BackgroundDragDropWrapper>
    </>
  );
};

BackgroundDragDrop.defaultProps = {
  className: '',
  onError: (error) => error,
  isOnclick: true,
};

BackgroundDragDrop.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
  onChangeFile: PropTypes.func.isRequired,
  onError: PropTypes.func,
  isOnclick: PropTypes.bool,
};

export default BackgroundDragDrop;
